import React from 'react';
import { Trophy, BarChart3 } from 'lucide-react';

const SubmitScoreModal = ({ 
  testResults, 
  formatTime, 
  setShowDetailedResults, 
  username, 
  setUsername, 
  resetTest, 
  submitToLeaderboard, 
  loading 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800 flex items-center justify-center p-2 sm:p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-6 sm:p-8 mx-2">
        <div className="text-center mb-6">
          <Trophy className="w-12 h-12 sm:w-16 sm:h-16 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">Test Complete!</h2>
          <div className="space-y-2 text-sm sm:text-base text-gray-600">
            <div>Score: {testResults.correct}/{testResults.total}</div>
            <div>Accuracy: {testResults.accuracy}%</div>
            <div>Time: {formatTime(testResults.timeSpent)}</div>
          </div>
        </div>
        
        {/* View Details Button */}
        <button
          onClick={() => setShowDetailedResults(true)}
          className="w-full mb-4 px-4 py-3 bg-blue-100 text-blue-700 rounded-lg font-semibold hover:bg-blue-200 transition-colors flex items-center justify-center gap-2 text-sm sm:text-base"
        >
          <BarChart3 className="w-4 h-4" />
          View Detailed Results
        </button>
        
        <div className="mb-6">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your name for leaderboard"
            className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none text-sm sm:text-base"
          />
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={resetTest}
            className="flex-1 px-4 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold text-sm sm:text-base"
          >
            Skip
          </button>
          <button
            onClick={submitToLeaderboard}
            disabled={loading}
            className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all disabled:opacity-50 text-sm sm:text-base"
          >
            {loading ? 'Submitting...' : 'Submit Score'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitScoreModal;